// extracted by mini-css-extract-plugin
module.exports = {"input":"SignUpInput_input__1tWOO","label":"SignUpInput_label__2mKSX"};